import { z } from "zod";

export const regex = {
  email: z
    .string()
    .min(1)
    .regex(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})+$/),
  password: z
    .string()
    .nonempty()
    .regex(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!#@$%^&*]).{8,}$/),
  dob: z
    .string()
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, "Date format must match DD/MM/YYYY")
    .optional(),
  zipcode: z
    .string()
    .regex(
      /(^\d{5}$)|(^\d{5}-\d{4}$)/,
      "Zipcode must match the following pattern: 33701 or 33701-4313",
    ),
};
